<template>
    <a-form :form="form" @submit.prevent="handleSubmit">
        <a-row :gutter="16">
            <a-col :span="12">
                <a-form-item :label="$t('modules.displayName')">
                    <a-input v-model="form.displayName" />
                </a-form-item>
            </a-col>
            <a-col :span="12">
                <a-form-item :label="$t('modules.icon')">
                    <MaterialIconPicker v-model="form.icon" />
                </a-form-item>
            </a-col>
        </a-row>

        <a-form-item :label="$t('modules.description')">
            <a-textarea v-model="form.description" :rows="4" />
        </a-form-item>

        <template v-if="module.type === 'module'">
            <a-divider>{{ $t("modules.menuApiSettings") }}</a-divider>
            <a-form-item>
                <a-checkbox v-model="form.module.settings.showInMainMenu">
                    {{ $t("modules.showInMainMenu") }}
                </a-checkbox>
            </a-form-item>
            <a-form-item>
                <a-checkbox v-model="form.module.settings.apiEnabled">
                    {{ $t("modules.apiAccess") }}
                </a-checkbox>
            </a-form-item>
        </template>
    </a-form>
</template>

<script>
import { mapState, mapActions } from "vuex";
import MaterialIconPicker from "../Module/MaterialIconPicker.vue";

export default {
    components: {
        MaterialIconPicker,
    },
    props: {
        module: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            form: {
                displayName: "",
                description: "",
                icon: "",
                module: {
                    settings: {
                        showInMainMenu: true,
                        apiEnabled: true,
                    },
                },
            },
        };
    },
    created() {
        this.initForm();
    },
    methods: {
        ...mapActions({
            updateModule: "module/updateModule",
            syncModules: "module/syncModules",
        }),
        initForm() {
            this.form.displayName = this.module.displayName || "";
            this.form.description = this.module.description || "";
            this.form.icon = this.module.icon || "";
            
            if (this.module.type === 'module' && this.module.module) {
                this.form.module.settings.showInMainMenu = this.module.module.settings?.showInMainMenu ?? true;
                this.form.module.settings.apiEnabled = this.module.module.settings?.apiEnabled ?? true;
            }
        },
        async handleSubmit() {
            try {
                const updatingFields = {
                    displayName: this.form.displayName,
                    description: this.form.description,
                    icon: this.form.icon,
                };
                
                if (this.module.type === 'module') {
                    updatingFields["module.settings.showInMainMenu"] = this.form.module.settings.showInMainMenu;
                    updatingFields["module.settings.apiEnabled"] = this.form.module.settings.apiEnabled;
                }
                
                await this.updateModule({
                    moduleName: this.module.moduleName,
                    updatingFields,
                });
                
                this.$message.success(this.$t("modules.updateSuccess"));
                this.$emit("success");
                this.syncModules();
            } catch (error) {
                this.$message.error(this.$t("modules.updateFailed"));
            }
        },
    },
    watch: {
        module: {
            handler() {
                this.initForm();
            },
            deep: true,
        },
    },
};
</script> 